(function () {
  'use strict';

  angular
    .module('component.addtocart', [])

    .component('buttonAddToCart', {
      require: {
        productCtrl: '?^^productDetail',
        comparatorCtrl: '?^^comparator'
      },
      bindings: {
        isProductButton: '<?',
        isCartButton: '<?',
        action: '&?',
        btnClass: '@',
        idLine: '<?',
        commentLine: '@?',
        id: '<idProduct',
        productQuantity: '<?',
        isPrimary: '<',
        isProductDetail: '<',
        addToCartActive: '<?',
        allowAddToCart: '<',
        price: '<productPrice',
        designation: '@productDesignation',
        img: '@productImg',
        url: '@productUrl',
        titleAdd: '@?',
        titleBtn: '@?',
        titleAlert: '@?',
        btnTooltip: '@',
        modalCtrl: '<',
        device: '<',
        isDilicom: '<'
      },
      templateUrl: 'component.addtocart.tpl',
      /* @ngInject */
      controller: ["$scope", "LoadService", function ($scope, LoadService) {
        var ctrl = this;

        ctrl.$onInit = function () {
          ctrl.js = $(document.body).data('js-components');
          LoadService.getService('AsyncComponentsService', { ctrl: ctrl, scope: $scope }, 'initAddToCart');
        };

        $scope.$on('logUpdate', function (event, value) {
          ctrl.isLogged = value;
        });

      }]
    });
})();
